import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../Redux/Actions/index";
import {
  showErrorToastMessage,
  showSuccessToastMessage,
} from "../../../component/Toasts/Toasts";
import { Button, Dropdown, InputGroup, Spinner } from "react-bootstrap";
import Select from "react-select";
import { Strings, addTaskLabels } from "../../../constant/Strings/index";
import "./TaskDetails.scss";
import "./style.scss";
import { BsCheckLg, BsXLg, BsGear } from "react-icons/bs";
// import { Form } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import ActivityTypeManagerModal from "../../../component/ModalComponent/ActivityTypeManagerModal";
import TaskNameManagerModal from "../../../component/ModalComponent/TaskNameManagerModal";
interface SelectOption {
  value: string;
  label: string;
}
interface ITaskDetailsState {
  taskName: string;
  activityType: string;
  clientId: string;
  subDepartmentId: string;
  employeeId: string;
  assignedHrbpId: string;
  priority: string | null; // This is the key: priority can be a string OR null
  status: string;
  startDate: string;
  dueDate: string;
  comments: string;
}

interface IAddTaskProps {
  hideAddModal: () => void;
  onAddSuccess: () => void; // This is the new callback prop
}

const AddTask = (props: IAddTaskProps) => {
  const didMountRef = useRef(false);
  const { hideAddModal, onAddSuccess } = props;
  const dispatch = useDispatch();

  const HR_ADMIN_ROLE = 'hr-admin';
  const isHrAdmin = (localStorage.getItem("role") || "").includes(HR_ADMIN_ROLE);

  const { getEmployeeData, getClientNameDetails } = useSelector(
    (state: any) => state.employeeReducer
  );
  const { hrbpTaskNamesByActivity } = useSelector(
    (state: any) => state.employeeReducer
  );
  const { allHrbpActivityTypes } = useSelector(
    (state: any) => state.employeeReducer
  );

  useEffect(() => {
    dispatch(actions.getClientNameAction());
    dispatch(actions.getEmployeeDataAction());
    dispatch(actions.getAllHrbpActivityTypesAction() as any);
  }, [dispatch]);

   useEffect(() => {
    if (allHrbpActivityTypes && allHrbpActivityTypes.data) {
      setActivityTypeOptions(allHrbpActivityTypes.data);
    }
  }, [allHrbpActivityTypes]);

  const [taskDetails, setTaskDetails] = useState<ITaskDetailsState>({
    taskName: "",
    activityType: "",
    clientId: "",
    subDepartmentId: "",
    employeeId: "",
    assignedHrbpId: "",
    priority: null,
    status: "Open",
    startDate: "",
    dueDate: "",
    comments: "",
  });
  const [taskNameOptions, setTaskNameOptions] = useState<string[]>([]);
  const [taskOptions, setTaskOptions] = useState<any[]>([]);
  const [isAddingNewTask, setIsAddingNewTask] = useState(false);
  const [newTaskName, setNewTaskName] = useState("");
  const [isSubmittingNewTask, setIsSubmittingNewTask] = useState(false);
  const [activityTypeOptions, setActivityTypeOptions] = useState<any[]>([]);
  const [isAddingNewActivityType, setIsAddingNewActivityType] = useState(false);
  const [newActivityTypeName, setNewActivityTypeName] = useState("");
  const [isSubmittingNewActivityType, setIsSubmittingNewActivityType] = useState(false);
  const [showActivityManager, setShowActivityManager] = useState(false);
  const [showTaskManager, setShowTaskManager] = useState(false);

  useEffect(() => {
    if (taskDetails.activityType) {
      dispatch(actions.getHrbpTasksByActivityTypeAction(taskDetails.activityType) as any);
    }
    setTaskDetails(currentDetails => ({
      ...currentDetails,
      taskName: ""
    }));
  }, [taskDetails.activityType, dispatch]);

  useEffect(() => {
    if (hrbpTaskNamesByActivity && hrbpTaskNamesByActivity.data) {
      setTaskOptions(hrbpTaskNamesByActivity.data);
    }
  }, [hrbpTaskNamesByActivity]);


  const [isFieldsDisabled, setIsFieldsDisabled] = useState(false);
  const [errors, setErrors] = useState({ taskName: "", startDate: "", dueDate: "", comments: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const employeeOptions: SelectOption[] = (getEmployeeData?.data || []).map((emp: any) => ({
    value: emp._id,
    label: `${emp.candidateName} ${emp.lastname || ""} - ${emp.employeeId}`,
  }));

  const clientOptions: SelectOption[] = (getClientNameDetails?.data || []).map((client: any) => ({
    value: client._id,
    label: client.clientName,
  }));
  const hrbpOptions: SelectOption[] = (getEmployeeData?.data || []).map((emp: any) => ({
    value: emp._id,
    label: `${emp.candidateName} ${emp.lastname || ""} - ${emp.employeeId}`,
  }));

  const handleEmployeeChange = (selectedOption: SelectOption | null) => {
    if (selectedOption) {
      const selectedEmployeeId = selectedOption.value;
      const fullEmployee = (getEmployeeData?.data || []).find((e: any) => e._id === selectedEmployeeId);
      if (fullEmployee) {
        const matchingClient = clientOptions.find((c: SelectOption) => c.label === fullEmployee.clientName);
        setTaskDetails({
          ...taskDetails,
          employeeId: fullEmployee._id,
          clientId: matchingClient ? matchingClient.value : "",
          subDepartmentId: fullEmployee.subDepartment || "",
          assignedHrbpId: fullEmployee.hrbpRef || "",
        });
        setIsFieldsDisabled(true);
      }
    } else {
      setTaskDetails({
        ...taskDetails,
        employeeId: "", clientId: "", subDepartmentId: "", assignedHrbpId: "",
      });
      setIsFieldsDisabled(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;

    setTaskDetails(prevDetails => ({
      ...prevDetails,
      [name]: value,
    }));
    const errorKey = name as keyof typeof errors;

    if (errors[errorKey]) {
      setErrors(prevErrors => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };
  const validate = () => {
    let isValid = true;
    const newErrors = { taskName: "", startDate: "", dueDate: "", comments: "" };
    if (!taskDetails.taskName.trim()) {
      newErrors.taskName = "Task Name is required";
      isValid = false;
    }
    if (taskDetails.comments.length > 500) {
      newErrors.comments = "Comments cannot exceed 500 characters.";
      isValid = false;
    }
    if (!taskDetails.startDate) {
      newErrors.startDate = "Start Date is required";
      isValid = false;
    }
    if (!taskDetails.dueDate) {
      newErrors.dueDate = "Due Date is required";
      isValid = false;
    }
    const currentYear = new Date().getFullYear();
    const maxYear = currentYear + 50;
    if (taskDetails.startDate) {
      const startYear = new Date(taskDetails.startDate).getFullYear();
      if (startYear < 2000 || startYear > maxYear) {
        newErrors.startDate = `Please enter a year between 2000 and ${maxYear}.`
        isValid = false;
      }
    }
    if (taskDetails.dueDate) {
      const dueYear = new Date(taskDetails.dueDate).getFullYear();
      if (dueYear < 2000 || dueYear > maxYear) {
        newErrors.dueDate = `Please enter a year between 2000 and ${maxYear}.`
        isValid = false;
      }
    }
    if (taskDetails.startDate && taskDetails.dueDate) {
      const start = new Date(taskDetails.startDate);
      const due = new Date(taskDetails.dueDate);
      if (due < start) {
        newErrors.dueDate = "Due Date cannot be earlier than Start Date";
        isValid = false;
      }
    }
    setErrors(newErrors);
    return isValid;
  };

  // Handle form submission
  const handleSubmit = () => {
  if (validate()) {
    setIsSubmitting(true);
    dispatch(
      actions.createHrbpActivityAction(taskDetails, (res: any) => {
        setIsSubmitting(false); 
        if (res?.code === 200) {
          showSuccessToastMessage("Task added successfully!");
          
          onAddSuccess(); 
          hideAddModal();
          
        } else {
          showErrorToastMessage(
            res.error.error_description || "Failed to add task"
          );
        }
      })
    );
  }
};
  const handleAddNewTask = () => {
    if (!newTaskName.trim()) {
      showErrorToastMessage("Please enter a name for the new task.");
      return;
    }
    setIsSubmittingNewTask(true);
    dispatch(
      actions.createNewTaskForActivityTypeAction(
        taskDetails.activityType,
        newTaskName,
        (res: any) => {
          setIsSubmittingNewTask(false);
          if (res?.data || res?.code === 200) {
            const createdName = res?.data?.name || newTaskName;
            setTaskOptions(prev => [...prev, { name: createdName, _id: res?.data?._id }]);
            setTaskDetails(prev => ({ ...prev, taskName: createdName }));
            setErrors(prev => ({ ...prev, taskName: "" }));
            setNewTaskName("");
            setIsAddingNewTask(false);
          } else {
            showErrorToastMessage(res?.error?.error_description || "Failed to add new task");
          }
        }
      ) as any
    );
  };
  const handleAddNewActivityType = () => {
    if (!newActivityTypeName.trim()) {
      showErrorToastMessage("Please enter a name for the new activity type.");
      return;
    }
    setIsSubmittingNewActivityType(true);

    dispatch(
      actions.createNewHrbpActivityTypeAction(
        newActivityTypeName,
        (res: any) => {
          setIsSubmittingNewActivityType(false);
          if (res?.data || res?.code === 200) {
            const createdName = res?.data?.name || newActivityTypeName;
            setActivityTypeOptions(prev => [...prev, { name: createdName, _id: res?.data?._id }]);
            setTaskDetails(prev => ({ ...prev, activityType: createdName, taskName: "" }));
            setNewActivityTypeName("");
            setIsAddingNewActivityType(false);
            dispatch(actions.getAllHrbpActivityTypesAction() as any);
          } else {
            showErrorToastMessage(res?.error?.error_description || "Failed to add new activity type");
          }
        }
      ) as any
    );
  };
  useEffect(() => {
    if (taskDetails.activityType && activityTypeOptions.length > 0) {
      const exists = activityTypeOptions.some((op: any) => op.name === taskDetails.activityType);
      if (!exists) {
        setTaskDetails(prev => ({ ...prev, activityType: "", taskName: "" }));
      }
    }
  }, [activityTypeOptions, taskDetails.activityType]);

  // 2. Clear Task Name if deleted
  useEffect(() => {
    if (taskDetails.taskName && taskOptions.length > 0) {
      const exists = taskOptions.some((op: any) => op.name === taskDetails.taskName);
      if (!exists) {
        setTaskDetails(prev => ({ ...prev, taskName: "" }));
      }
    }
  }, [taskOptions, taskDetails.taskName]);

  const { cancel, submit } = Strings;
  const { taskName, activityType, client, HRBP, Priority, dueDate, taskComment } =
    addTaskLabels;

  return (
    <div className="container">
      <div className="row g-3">
        {/* Row 1: Activity Type and Task Name */}
        <div className="col-md-6">
          <label className="form-label">{activityType}<span className="required">*</span></label>

          {isAddingNewActivityType ? (
            <InputGroup className="task-name-dropdown"> {/* Re-using the same class for consistent styling */}
              <Form.Control
                placeholder="Enter new activity type"
                value={newActivityTypeName}
                onChange={(e: any) => setNewActivityTypeName(e.target.value)}
                autoFocus
                onKeyDown={(e: any) => e.key === 'Enter' && handleAddNewActivityType()}
              />
              <Button
                variant="primary"
                onClick={handleAddNewActivityType}
                disabled={isSubmittingNewActivityType || !newActivityTypeName.trim()}
                className="d-flex align-items-center justify-content-center"
              >
                {isSubmittingNewActivityType ? <Spinner animation="border" size="sm" /> : <BsCheckLg />}
              </Button>
              <Button
                variant="outline-secondary"
                onClick={() => setIsAddingNewActivityType(false)}
                className="pe-2 d-flex align-items-center justify-content-center"
              >
                <BsXLg />
              </Button>
            </InputGroup>
          ) : (
            <div className="task-name-dropdown">
              <Dropdown
                onSelect={(key: any) => {
                  if (key === "__ADD_NEW_ACTIVITY_TYPE__") {
                    setIsAddingNewActivityType(true);
                  } else {
                    setTaskDetails({ ...taskDetails, activityType: key });
                  }
                }}
              >
                <Dropdown.Toggle
                  variant="light"
                  className="w-100 text-start d-flex justify-content-between align-items-center"
                >
                  <span className="dropdown-text-label">
                    {taskDetails.activityType || "Select an activity..."}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="w-100">
                  {isHrAdmin && (
                    <>
                      <Dropdown.Item eventKey="__ADD_NEW_ACTIVITY_TYPE__" className="add-new-task-option">
                        + Add new activity type...
                      </Dropdown.Item>
                      <Dropdown.Item 
                        onClick={() => setShowActivityManager(true)} 
                        className="text-secondary"
                      >
                        <BsGear /> Manage Activity Types
                      </Dropdown.Item>
                      <Dropdown.Divider />
                    </>
                  )}

                  {activityTypeOptions.length > 0 ? (
                    activityTypeOptions.map((type: any, index: number) => (
                      <Dropdown.Item key={index} eventKey={type.name}>{type.name}</Dropdown.Item>
                    ))
                  ) : (
                    <Dropdown.Item disabled>Loading activities...</Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
        </div>

        <div className="col-md-6">
          <label className="form-label">{taskName}<span className="required">*</span></label>

          {isAddingNewTask ? (
            <InputGroup className="task-name-dropdown">
              <Form.Control
                placeholder="Enter new task name"
                value={newTaskName}
                onChange={(e: any) => setNewTaskName(e.target.value)}
                autoFocus
                onKeyDown={(e: any) => e.key === 'Enter' && handleAddNewTask()}
              />
              <Button
                variant="primary"
                onClick={handleAddNewTask}
                disabled={isSubmittingNewTask || !newTaskName.trim()}
                className="d-flex align-items-center justify-content-center"
              >
                {isSubmittingNewTask ? <Spinner animation="border" size="sm" /> : <BsCheckLg />}
              </Button>
              <Button
                variant="outline-secondary"
                onClick={() => setIsAddingNewTask(false)}
                className="pe-2 d-flex align-items-center justify-content-center"
              >
                <BsXLg />
              </Button>
            </InputGroup>
          ) : (
            <div className="task-name-dropdown">
              <Dropdown
                onSelect={(key: any) => {
                  if (key === "__ADD_NEW__") {
                    setIsAddingNewTask(true);
                  } else {
                    setTaskDetails({ ...taskDetails, taskName: key });
                    setErrors({ ...errors, taskName: "" });
                  }
                }}
              >
                <Dropdown.Toggle
                  variant="light"
                  className="w-100 text-start d-flex justify-content-between align-items-center"
                  disabled={!taskDetails.activityType}
                >
                  <span className="dropdown-text-label">
                    {taskDetails.taskName || "Select a task..."}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="w-100">
                  {isHrAdmin && (
                    <>
                      <Dropdown.Item eventKey="__ADD_NEW__" className="add-new-task-option">
                        + Add new task...
                      </Dropdown.Item>
                      <Dropdown.Item 
                        onClick={() => setShowTaskManager(true)} 
                        className="text-secondary"
                      >
                        <BsGear /> Manage Tasks
                      </Dropdown.Item>
                      <Dropdown.Divider />
                    </>
                  )}

                  {taskOptions.length > 0 ? (
                    taskOptions.map((task: any, index: number) => (
                      <Dropdown.Item key={index} eventKey={task.name}>{task.name}</Dropdown.Item>
                    ))
                  ) : (
                    <Dropdown.Item disabled>No predefined tasks found</Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
          {errors.taskName && <p className="error">{errors.taskName}</p>}
        </div>


        {/* Row 2: Employee Selection */}
        <div className="col-md-12 mt-3">
          <label className="form-label">Employee</label>
          <Select
            options={employeeOptions}
            onChange={handleEmployeeChange}
            isClearable
          />
        </div>

        {/* Row 3: Client, Sub-Department, Assigned HRBP */}
        <div className="col-md-4 mt-3">
          <label className="form-label">{client}</label>
          <Select
            options={clientOptions}
            value={clientOptions.find((c: SelectOption) => c.value === taskDetails.clientId)}
            onChange={(selected: any) => setTaskDetails({ ...taskDetails, clientId: selected.value })}
            isDisabled={isFieldsDisabled}
            placeholder={isFieldsDisabled ? "No Assigned Client" : "Select..."}
          />
        </div>
        <div className="col-md-4 mt-3">
          <label className="form-label">Sub-Department</label>
          <input
            type="text"
            className="form-control"
            value={taskDetails.subDepartmentId || (isFieldsDisabled ? "No Sub-Department" : "")}
            disabled
            style={{ fontStyle: !taskDetails.subDepartmentId && isFieldsDisabled ? 'italic' : 'normal' }}
          />
        </div>
        <div className="col-md-4 mt-3">
          <label className="form-label">{HRBP}</label>
          <Select
            options={hrbpOptions}
            value={hrbpOptions.find((h: SelectOption) => h.value === taskDetails.assignedHrbpId)}
            onChange={(selected: any) => setTaskDetails({ ...taskDetails, assignedHrbpId: selected.value })}
            isDisabled={isFieldsDisabled}
            placeholder={isFieldsDisabled ? "No Assigned HRBP" : "Select..."}
          />
        </div>

        {/* Row 4: Start Date and Due Date */}
        <div className="col-md-6 mt-3">
          <label className="form-label">Start Date<span className="required">*</span></label>
          <input type="date" className="form-control" value={taskDetails.startDate} onChange={(e) => setTaskDetails({ ...taskDetails, startDate: e.target.value })} />
          {errors.startDate && <p className="error">{errors.startDate}</p>}
        </div>
        <div className="col-md-6 mt-3">
          <label className="form-label">{dueDate}<span className="required">*</span></label>
          <input type="date" className="form-control" value={taskDetails.dueDate} onChange={(e) => setTaskDetails({ ...taskDetails, dueDate: e.target.value })} />
          {errors.dueDate && <p className="error">{errors.dueDate}</p>}
        </div>

        {/* Row 5: Priority (Non-mandatory) and Status */}
        <div className="col-md-6 mt-3">
          <label className="form-label">{Priority}</label> {/* No asterisk */}
          <Dropdown
            onSelect={(key: string | null) => {
              setTaskDetails({ ...taskDetails, priority: key === "" ? null : key });
            }}
          >
            <Dropdown.Toggle variant="light" className="w-100 text-start d-flex justify-content-between align-items-center">
              {taskDetails.priority || "Select..."}
            </Dropdown.Toggle>
            <Dropdown.Menu className="w-100">
              <Dropdown.Item eventKey="">None</Dropdown.Item>
              <Dropdown.Item eventKey="Low">Low</Dropdown.Item>
              <Dropdown.Item eventKey="Medium">Medium</Dropdown.Item>
              <Dropdown.Item eventKey="High">High</Dropdown.Item>
              <Dropdown.Item eventKey="Urgent">Urgent</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* --- THIS IS THE FIX: Added back the Status dropdown --- */}
        <div className="col-md-6 mt-3">
          <label className="form-label">Status<span className="required">*</span></label>
          <Dropdown onSelect={(key: any) => setTaskDetails({ ...taskDetails, status: key })}>
            <Dropdown.Toggle variant="light" className="w-100 text-start d-flex justify-content-between align-items-center">{taskDetails.status}</Dropdown.Toggle>
            <Dropdown.Menu className="w-100">
              <Dropdown.Item eventKey="Open">Open</Dropdown.Item>
              <Dropdown.Item eventKey="Closed">Closed</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        {/* -------------------------------------------------------- */}

        {/* Row 6: Comments */}
        <div className="col-md-12 mt-3">
          <label className="form-label">{taskComment}</label>
          <textarea className="form-control" name="comments" value={taskDetails.comments} onChange={handleInputChange} maxLength={500}></textarea>
          <div className="d-flex justify-content-between">
            {errors.comments && <p className="error mb-0">{errors.comments}</p>}
            <small style={{ marginLeft: 'auto', color: '#6c757d', fontSize: '12px' }}>
              {taskDetails.comments.length} / 500
            </small>
          </div>
        </div>
      </div>

      <div className="modal-btn-wrapper mt-5 mx-auto">
        <div>
          <Button className="add-submit-button buttonsize" onClick={handleSubmit} disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                <span className="ms-2">Submitting...</span>
              </>
            ) : (
              submit
            )}
          </Button>
        </div>
      </div>
      <ActivityTypeManagerModal 
        show={showActivityManager}
        onHide={() => setShowActivityManager(false)}
        data={activityTypeOptions.map((d: any) => ({ _id: d._id, name: d.name }))}
        refreshData={() => dispatch(actions.getAllHrbpActivityTypesAction() as any)}
      />

      <TaskNameManagerModal 
        show={showTaskManager}
        onHide={() => setShowTaskManager(false)}
        data={taskOptions.map((d: any) => ({ _id: d._id, name: d.name }))}
        allTasksOptions={taskOptions.map((d: any) => ({ value: d._id, label: d.name }))}
        
        refreshData={() => {
            if (taskDetails.activityType) {
                dispatch(actions.getHrbpTasksByActivityTypeAction(taskDetails.activityType) as any);
            }
        }}
      />
    </div>
  );
};

export default AddTask;